import React from "react"
import { Flex } from "theme-ui"
import styled from "@emotion/styled"
import PromotionsCard from "components/cards/promotions-card"

const PromotionsWrapper = styled(Flex)`
    margin: auto;
    flex-wrap: wrap;
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        padding: 1rem;
    }
`


// markup
const IndexPage = ({ data, url }) => {
    return (
        <PromotionsWrapper>
            {data.edges.map((programs, idx) => {
                const { node } = programs
                return (
                    <PromotionsCard
                        key={idx}
                        url={url}
                        slug={node.slug}
                        title={node.title}
                        summary={node.summary}
                        imageFile={node.image}
                    />
                )
            })}
        </PromotionsWrapper>
    )
}

export default IndexPage
